module.exports = __webpack_public_path__ + "img/IF2_clean.5a5069dc.png";